'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const SanitizeHtml = require('../../../global/components/SanitizeHtml');
const {trackAttributeClick} = require('../../actions/pdpTrackingActions.es');

class DetailsMultiline extends React.Component {
    constructor(props) {
        super(props);
        this.fireTracking = this.fireTracking.bind(this);
    }

    fireTracking() {
        this.context.executeAction(trackAttributeClick, {label: this.props.gaLabel});
    }

    render() {
        let detailItems = this.props.contents.map(content => {
            if (content.isLink && content.link && !this.props.isPrintPage) {
                return (
                    <div key={content.value}>
                        <a className="pdp-details-entry-content-link" href={content.link} onClick={this.fireTracking}>
                            <SanitizeHtml content={content.value} />
                        </a>
                    </div>
                );
            } else {
                return (
                    <div key={content.value}>
                        <SanitizeHtml content={content.value} />
                    </div>
                );
            }
        });

        return (
            <li className="pdp-details-entry">
                <div className="pdp-details-entry-title-container">
                    <span className="pdp-details-entry-title">{this.props.title}</span>
                </div>
                <div className="pdp-details-entry-content-container" data-tn={this.props.testName}>
                {detailItems}
                </div>
            </li>
        );
    }
}

DetailsMultiline.contextTypes = {
    executeAction: PropTypes.func.isRequired
};

DetailsMultiline.defaultProps = {
    isPrintPage: false
};

DetailsMultiline.propTypes = {
    contents: PropTypes.array.isRequired,
    gaLabel: PropTypes.string,
    testName: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    isPrintPage: PropTypes.bool
};

module.exports = DetailsMultiline;



// WEBPACK FOOTER //
// ./assets/js/newPdp/details/components/DetailsMultiline.jsx